import {
  Input as ChakraInput,
  InputGroup as ChakraInputGroup,
  InputAddon as ChakraInputAddon,
  InputElement as ChakraInputElement,
  type InputProps as ChakraInputProps,
  type InputGroupProps as ChakraInputGroupProps
} from "@chakra-ui/react";

export type InputProps = Omit<ChakraInputProps, "size"> & {
  size?:
    | ChakraInputProps["size"]
    | string
    | Record<string, string>
    | Array<string | null>;
  invalid?: boolean;
};

export function Input({ size, invalid, ...props }: InputProps) {
  return (
    <ChakraInput
      size={size as ChakraInputProps["size"]}
      {...(invalid
        ? { "aria-invalid": true as const, "data-invalid": "" }
        : {})}
      {...props}
    />
  );
}

export function InputGroup(props: ChakraInputGroupProps) {
  return <ChakraInputGroup width="100%" {...props} />;
}

export { ChakraInputAddon as InputAddon, ChakraInputElement as InputElement };
